export type AppLanguageCode = 'en' | 'fi' | 'de'

export const SUPPORTED_APP_LANGUAGES = [
  { code: 'en' as const, name: 'English', flag: '🇺🇸' },
  { code: 'fi' as const, name: 'Suomi', flag: '🇫🇮' },
  { code: 'de' as const, name: 'Deutsch', flag: '🇩🇪' },
]

export const SUPPORTED_APP_LANGUAGE_CODES = SUPPORTED_APP_LANGUAGES.map((language) => language.code)

/** ISO 3166-1 alpha-2 country codes that map to a default app language. */
export const COUNTRY_TO_APP_LANGUAGE: Record<string, AppLanguageCode> = {
  FI: 'fi',
  DE: 'de',
}

export const USER_DETECTED_COUNTRY_CACHE_KEY = 'user_detected_country_code'

export function isSupportedAppLanguage(languageCode: string | null | undefined): languageCode is AppLanguageCode {
  return SUPPORTED_APP_LANGUAGE_CODES.includes(languageCode as AppLanguageCode)
}

export function appLanguageForCountry(countryCode: string | null | undefined): AppLanguageCode | null {
  if (!countryCode) return null
  return COUNTRY_TO_APP_LANGUAGE[countryCode.trim().toUpperCase()] ?? null
}
